module.exports = __webpack_public_path__ + "img/misja-brief.13d59f1f.png";